export default "__VITE_ASSET__CoVEhll9__"